import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { FormattedMessage } from 'react-intl';
import { Button } from 'reactstrap';

import { getUrl } from 'Redux/ducks/epic';
import { history } from 'Redux/store';
import { unlinkEpic } from 'Redux/ducks/auth';
import getUrlParameter from 'Helpers/Url/GetUrlParameter';
import MessageBox from 'Components/Utility/MessageBox';

function EpicConnect(props) {
  const [connecting, setConnecting] = useState(false);
  const [message, setMessage] = useState(null);

  const saveRedirect = () => {
    const url = props.location.pathname;
    localStorage.setItem('epicRedirect', url);
  };

  useEffect(() => {
    if (!props._id) {
      history.push('/');
    }
    if (props._id) {
      if (getUrlParameter('message')) {
        setMessage(getUrlParameter('message'));
      }
      if (!props.url && (!props.epic || isEmpty(props.epic))) {
        getUrl();
      }
    }
  }, [props]);

  const { _id, epic, url, primaryBtn } = props;

  if (!_id) return false;

  return (
    <div className="account-connection">
      <div className="connection-icon epic">
        <img
          loading="lazy"
          src="https://cdn.fanatical.com/production/icons/drm/light/epicgames.svg"
          alt="Epig Games Icon"
          width="100%"
          height="100%"
        />
      </div>
      <div className="connection-text-container">
        <div className="main-text">
          {(!epic || isEmpty(epic)) &&
            <FormattedMessage id="account.setting.epic-connect.not-linked" defaultMessage="Epic Account Not Linked" />
          }
          {epic && !isEmpty(epic) &&
            <React.Fragment>
              <FormattedMessage id="epic-connect.connected" defaultMessage="Connected to " />
              <b>{epic.displayName}</b>
            </React.Fragment>
          }
        </div>
        <div className="connection-unlink">
          {(!epic || isEmpty(epic)) &&
            <Button
              disabled={connecting}
              color="link"
              className={`btn btn-link-account ${primaryBtn ? 'btn-primary' : ''}`}
              tag={'a'}
              href={url}
              onClick={() => {
                saveRedirect();
                setConnecting(true);
              }}
            >
              {!connecting &&
                <FormattedMessage id="account.setting.button.epic.connect" defaultMessage="Link Epic Games Account" />
              }
              {connecting &&
                <FormattedMessage id="account.setting.button.epic.loading" defaultMessage="Connecting" />
              }
            </Button>
          }
          {epic && !isEmpty(epic) &&
            <button type="button" className={`btn btn-unlink-account ${primaryBtn ? 'btn-primary' : ''}`} onClick={props.unlinkEpic}>
              <FormattedMessage id="epic-connect.disconnected" defaultMessage="Disconnect" />
            </button>
          }
        </div>
      </div>

      {message &&
        <div className="mb-3">
          <MessageBox
            dismissible
            type="error"
            title="Error"
            message={message}
            supportLink={360007075098}
            closeFunction={() => { setMessage(false); }}
          />
        </div>
      }
    </div>
  );
}

EpicConnect.propTypes = {
  _id: PropTypes.string,
  epic: PropTypes.shape({}),
  unlinkEpic: PropTypes.func.isRequired,
  url: PropTypes.string,
  primaryBtn: PropTypes.bool,
};

EpicConnect.defaultProps = {
  _id: null,
  epic: {},
  location: {
    search: '',
    pathname: '',
  },
  url: '',
  primaryBtn: false,
};

const mapStateToProps = ({
  auth: { _id, epic },
  router: { location },
  epicURL: { url },
}) => ({
  location,
  _id,
  epic,
  url,
});

const mapDispatchToProps = { unlinkEpic };

export default connect(mapStateToProps, mapDispatchToProps)(EpicConnect);
